import { useParams, Navigate, Route, Routes } from 'react-router-dom'
import { ChatbotRoutes } from 'entities/ExportRouters'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ChatbotPath } from 'pages/chatbot/route/chatbotPath'
import { Configure } from 'pages/chatbot/ui/UnifiedAgent/ui/Configure/Configure'
import { ChatbotEditV2Layout } from 'pages/chatbot/pages/chatbotEdit/layout/ChatbotEditV2Layout'
import { Chat } from 'pages/chatbot/ui/UnifiedAgent/ui/Chat/Chat'
import { ChatbotEditOldPage } from '../ui/ChatbotEditOldPage'

export const ChatbotEditRouter = () => {
  const { featureFlagsStore } = useEntitiesContext()
  const { agentId } = useParams()

  if (!featureFlagsStore.unified_agent_enabled) {
    return (
      <Routes>
        <Route index element={<ChatbotEditOldPage />} />
        <Route path='*' element={<Navigate to={ChatbotPath.edit(Number(agentId))} replace />} />
      </Routes>
    )
  }

  return (
    <Routes>
      <Route element={<ChatbotEditV2Layout />}>
        <Route index element={<Navigate to={ChatbotRoutes.chat} replace />} />
        <Route path={ChatbotRoutes.chat} element={<Chat />} />
        <Route path={ChatbotRoutes.config} element={<Configure />} />
      </Route>
      <Route path='*' element={<Navigate to={ChatbotRoutes.chat} replace />} />
    </Routes>
  )
}
